jQuery(function ($) {
  console.log('XXXXX started');
});
